import { useFormContext, useWatch } from 'react-hook-form';
import { DataType } from 'src/components/formEditor/uiEditor/uiEditor';

export const useAnswerValue = (dataKey: string) => {
  const form = useFormContext<DataType>();
  const value = useWatch({
    name: dataKey,
    control: form.control,
  });

  return value;
};
